export default {
  removalDialogMessage: name => `Deseja excluir a pasta ${name}?`,
  buttonNew: 'Novo',
  private: 'Privada',
  public: 'Pública',
};
